import { IFacultyDashboard } from "../../../models/dashboard/facultyDashboard";
import { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import TasksOverview from "./components/task/tasksOverview";
import FacultyQuickLinks from "./components/facultyQuickLinks";
import FacultyResourcesWidgets from "./components/facultyResourcesWidgets";
import FacultyApps from "./components/facultyApps";
import {
  getPageBlockData,
  greetings,
} from "../../../common-functions/commonFunctions";
import { getCurrentUserData } from "../../../action/user/userProfileActionCreator";
import WorkLoad from "./components/workLoad";
import { getSnapShots } from "../../../action/masters/snapShotActionCreator";
import { pageBlockId } from "../../../constants/pageBlocks";
import WeekCalendar from "../../../common-components/calendar/weekCalendar";

const FacultyDashboad = (props: IFacultyDashboard) => {
  const { userInfo, getSnapShots } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    getSnapShots();
  }, []);

  return (
    <>
      <div className="row mb-3 facldash-mobile">
        <div className="dash-title col-lg-6">
          <h2 className="mb-2">{greetings()}, {userInfo?.displayName}</h2>
          <p>Welcome! Your Dashboard offers quick access to Widgets and Apps for teaching, communication, and course planning.  Access the sidebar menu to view all your academic and campus resources.</p>
        </div>
      </div>
      <div className="faculty-wrap">
        <div className="row mb-s3">
          <div className="col-lg-4 mb-3">
            <FacultyResourcesWidgets />
          </div>
          <div className="col-lg-4 mb-3">
            <FacultyApps />
          </div>
          <div className="col-lg-4 mb-3">
            <FacultyQuickLinks />
          </div>
          <div className="col-lg-4 mb-3">
            <TasksOverview />
          </div>
          <div className="col-lg-4 mb-3">
            <WorkLoad />
          </div>
          <div className="col-lg-4 mb-3">
            <WeekCalendar />
          </div>
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getSnapShots: () => getSnapShots(),
};

function mapStateToProps(state: any) {
  return {
    userInfo: state.userDetails.userProfileData,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FacultyDashboad);
